/* eslint-disable no-param-reassign */
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import FileSaver from 'file-saver'
import { ApiProvider } from '@leverege/api-redux'
import { Text, Button, Flex, Content, Popup, Pane, Label, Toast, Dialog, Dialogs } from '@leverege/ui-elements'
import { ProjectReader, CreateProject } from '@leverege/api-copy'
import { TextInput, FormRow, IconPopover, YesNoDialog, Loading, ProjectIcon } from '~/views'

import ProjectActions from '~/actions/ProjectActions'

import style from './style.css'
import ImportResults from './ImportResults'

class HomeScreen extends React.Component {

  static contextType = ApiProvider.Context
  static propTypes = {
    projects : PropTypes.object.isRequired
  }

  constructor( props ) {
    super( props )
    this.importFile = React.createRef()
    this.state = { 
      showDialog : false,
      newProjectName : undefined,
      newProjectIcon : undefined,
      duplicateProject : null,
      deleteName : null,
      deleteProject : null,
      deleteMode : false,
      showDeleteDialog : false,
      copying : false,
      copyingTitle : 'Exporting Project...',
      copyStatus : null
    }
  }
  
  componentDidMount() {
    const { dispatch } = this.props
    dispatch( ProjectActions.getProjects( ) );
  }

  onProjectClicked( projectId ) {
    const { history } = this.props
    history.push( `/project/${projectId}/blueprint` )
  }

  // onAddProject = () => {
  //   this.setState( { deleteMode : false, showDeleteDialog : false, deleteProject : null, showDialog : true, duplicateProject : null  } ) 
  // }

  onAddProject = ( evt ) => {
    this.setState( { 
      deleteMode : false, 
      showDeleteDialog : false, 
      deleteProject : null, 
      duplicateProject : null,
      importProject : null,
      showDialog : true } ) 
  }

  onChangeName = ( name, err ) => {
    this.setState( { newProjectName : name } )
  }

  onChangeIcon = ( icon, err ) => {
    this.setState( { newProjectIcon : icon } )
  }

  onCreateProject = () => {
    const { dispatch, history } = this.props
    const { newProjectName, newProjectIcon : icon, duplicateProject, importProject } = this.state

    let name = newProjectName
    if ( name == null ) {
      name = 'My Amazing Project'
    } else {
      name = name.trim()
      if ( name.length === 0 ) {
        name = 'My Amazing Project'
      }
    }

    this.setState( { newProjectName : undefined, newProjectIcon : undefined, showDialog : false } )

    if ( duplicateProject ) {
      this.onDoDuplicateProject( { project : duplicateProject, name, icon } )
    } else if ( importProject ) {
      this.onImportProject( { json : importProject, name, icon } )
    } else {
      dispatch( ProjectActions.createProject( { name, icon }, history ) )
    }
  } 
  
  onCancelProject = () => {
    this.setState( { showDialog : false, newProjectName : null, duplicateProject : null } ) 
  }

  onDeleteMode = ( ) => {
    const { deleteMode } = this.state
    this.setState( { deleteMode : !deleteMode } )
  }

  onDelete = ( evt ) => {
    const project = evt.data
    this.setState( { deleteProject : project, showDeleteDialog : true } )
  }

  onChangeDeleteName = ( name, err ) => {
    this.setState( { deleteName : name } )
  }

  onEnterInDeleteProject = ( evt ) => {
    if ( evt.key === 'Enter' ) {
      this.onDeleteProject()
    }
  }
  
  onDeleteProject = () => {
    const { dispatch } = this.props
    const { deleteName, deleteProject } = this.state

    if ( deleteProject == null || deleteName !== 'DELETE' ) {
      return
    }

    this.setState( { deleteMode : false, deleteProject : null, deleteName : null, showDeleteDialog : false } )

    dispatch( ProjectActions.deleteProject( deleteProject ) )
  }

  onCancelDeleteProject = () => {
    this.setState( { deleteMode : false, showDeleteDialog : false, deleteName : null, deleteProject : null } ) 
  }

  onExportProject = ( evt ) => {
    const prj = evt.data
    this.setState( { copyingTitle : 'Exporting Project...' } )
    const status = ( str ) => {
      this.setState( { copying : true, copyStatus : str } )
    }
    const r = ProjectReader.read( { api : this.context, projectId : prj.id, status } )
    
    r.then( 
      ( json ) => {
        let fileName = `${json.project.name}.json`
        fileName = fileName.replace( ' ', '_' ).replace( '/', '' )
        
        const blob = new Blob( [ JSON.stringify( json, null, 2 ) ], { type : 'application/json' } );
        FileSaver.saveAs( blob, fileName )
        this.setState( { copying : false, copyStatus : null } )

      }, 
      ( ex ) => {
        Toast.error( [ 'Project Export Failed', ex.message ] )
        this.setState( { copying : false, copyStatus : null } )

      } 
    )
  }

  onDuplicateProject = ( evt ) => {
    this.setState( { 
      deleteMode : false, 
      showDeleteDialog : false, 
      deleteProject : null, 
      newProjectName : `${evt.data.name} Copy`,
      newProjectIcon : evt.data.icon || null,
      duplicateProject : evt.data,
      showDialog : true } ) 
  }

  onDoDuplicateProject = ( opts ) => {
    
    const { project : prj, name, icon } = opts
    this.setState( { copyingTitle : 'Duplicating Project...', importProject : null } )
    const status = ( ...str ) => {
      this.setState( { copying : true, copyStatus : str.join( ' ' ) } )
    }
    const r = ProjectReader.read( { api : this.context, projectId : prj.id, status } )
    
    r.then( 
      async ( json ) => {
        this.onImportProject( { json, name, icon } )
      }, 
      ( ex ) => {
        Toast.error( [ 'Project Export Failed', ex.message ] )
        this.setState( { copying : false, copyStatus : null } )

      } 
    )
  
  }

  onOpenImportFile = ( evt ) => {
    this.importFile.current.value = null
    this.importFile.current.click()
  }

  onImportFile = ( evt ) => {
    const reader = new FileReader( )
    reader.onload = ( ) => {
      try {
        const json = JSON.parse( reader.result )
        if ( json.project ) {
          this.setState( { 
            deleteMode : false, 
            showDeleteDialog : false, 
            deleteProject : null, 
            newProjectName : `${json.project.name} Copy`,
            newProjectIcon : json.project.icon || null,
            copyingTitle : 'Import Project...',
            duplicateProject : null,
            importProject : json,
            showDialog : true } ) 

          // this.setState( { 
          //   copying : true, 
          //   copyingTitle : 'Importing Project...' 
          // } )

          // const status = ( ...str ) => {
          //   this.setState( { copying : true, copyStatus : str.join( ' ' ) } )
          // }
      
          // this.onImportProject( { json, status } )
        } else {
          Toast.error( [ 'The file does not look like a Profile File' ] )
        }
      } catch ( x ) {
        console.log( x )
        Toast.error( [ 'Error loading Project file', x.message ] )
      }
    }
    if ( evt?.target?.files?.[0] ) {
      reader.readAsText( evt.target.files[0] )
    }
  }

  async onImportProject( { json, name, icon } ) {
    const status = ( ...str ) => {
      this.setState( { copying : true, copyStatus : str.join( ' ' ) } )
    }
    json.project.name = name || `${json.project.name} Copy`
    json.project.icon = icon || json.project.icon || null
    if ( json.project.icon == null ) {
      delete json.project.icon
    }
    status( 'Creating Project' )
    const { project, errors, notes } = await CreateProject.create( json, { api : this.context, status } )
    const { dispatch } = this.props
    dispatch( ProjectActions.getProjects( ) )
    Dialogs.show( { 
      component : ( prps ) => {
        const onOkay = ( e ) => {
          
          prps.onClose()
          const { history } = this.props
          history.push( `/project/${project.id}/blueprint` )

        }
        const onCancel = ( e ) => {
          prps.onClose()
        }
        return (
          <ImportResults.Dialog 
            {...prps} 
            okay="Open Project"
            cancel="Done"
            onOkay={onOkay} 
            onCancel={onCancel}
            project={project} 
            notes={notes} 
            errors={errors}/>
        )
        
      }
    } )
    console.log( 'errors=', errors, notes )
    this.setState( { copying : false, copyStatus : null } )   
  }

  render() {
    const { projects } = this.props
    const { 
      deleteProject, showDialog, newProjectName, newProjectIcon, duplicateProject, importProject,
      showDeleteDialog, deleteName, copying, copyStatus, copyingTitle } = this.state

    if ( projects == null ) {
      return ( <div>We&apos;re lost</div> )
    }

    if ( projects.status === ProjectActions.LOADING_PROJECTS ) {
      return ( <Loading show message="Loading..." /> )
    }
    if ( projects.status != null && typeof projects.status === 'object' ) {
      return ( 
        <div>
          {`Error loading projects ${projects.status.status}, ${projects.status.message}`}
        </div>
      )
    }

    const popover = (
      <IconPopover
        title={(
          <Flex variant="rowM">
            <ProjectIcon
              project={{
                icon : newProjectIcon,
                name : newProjectName
              }} />
            <Text>Set Icon</Text>
          </Flex>
        )}
        value={newProjectIcon}
        onChangeIcon={this.onChangeIcon} />
    )

    const children = []

    projects.projects.forEach( ( e, index ) => { 
      const header = e.color ? { borderTop : `8px solid ${e.color}`, padding : '8px 16px 16px 16px' } : { borderTop : '8px solid white', padding : '8px 16px 16px 16px' }
      children.push(
        <div key={e.id} style={{ display : 'inline-block' }}>
          <Pane
            variant="project"
            style={header}
            onClick={() => { this.onProjectClicked( e.id ) }}>
            <Flex
              variant="projectButton"
              className={style.projectItem}>
              <Flex
                variant="rowM"
                align="baseline"
                justify="flex-start">
                <ProjectIcon project={e} />
                <Text variant="projectTitle">{e.name}</Text>
              </Flex>
              <Flex
                className={style.fullWidth}
                justify="space-between">
                <Text variant="body3">Created on {moment( e.created ).format( 'L' )}</Text>
                <Popup toggleVariant="disclosure">
                  <Popup.Item icon="fa fa-copy fa-fw" eventData={e} onClick={this.onDuplicateProject}>Duplicate Project</Popup.Item>
                  <Popup.Item icon="fa fa-download fa-fw" eventData={e} onClick={this.onExportProject}>Export Project</Popup.Item>
                  <Popup.Divider/>
                  <Popup.Item icon="fa fa-trash fa-fw" eventData={e} onClick={this.onDelete}>Delete Project</Popup.Item>
                </Popup>
              </Flex>
            </Flex>
          </Pane>
        </div>
      )
    } )
    return (
      <Content relative>
        <Content.Header className={style.headerBar}>
          <Flex variant="header">
            <Text variant="screenTitle">Projects</Text>
            <Flex>
              <Button
                variant="add"
                onClick={this.onAddProject}>
                New Project
              </Button>
              <Popup icon="fa fa-ellipsis-v fa-fw">
                <Popup.Item onClick={this.onOpenImportFile}>Import Project...</Popup.Item>
              </Popup>
              <input type="file" 
                style={{ display : 'none' }}
                ref={this.importFile}
                accept="application/json"
                onChange={this.onImportFile}/>
            </Flex>
          </Flex>
        </Content.Header>
        <Content.Area className={style.area}>
          <Flex
            variant="collection">
            {children}
          </Flex>
          <Dialog 
            title={copyingTitle}
            onClose={() => { }}
            show={copying} 
            escapeWillClose={false}
            clickWillClose={false}
            buttons={<div/>} >
            {copyStatus}
          </Dialog>
          <YesNoDialog
            show={showDialog}
            className={style.newProjectDialog}
            title={duplicateProject ? 'Duplicate Project' : importProject ? 'Import Project' : 'New Project'}
            yes={duplicateProject ? 'Duplicate' : importProject ? 'Import' : 'Create'}
            no="Cancel"
            headerClassName={style.newProjectDialogHeader}
            bodyClassName={style.newProjectDialogBody}
            contentVariant="projectDialogContent"
            message={(
              <Flex
                variant="colL"
                align="flex-start">
                <FormRow
                  variant="colM"
                  align="flex-start">
                  <Text variant="body3">What is the name of your new project?</Text>
                  <TextInput
                    focus
                    style={{ width : '100%' }}
                    hint="My Amazing Project"
                    value={newProjectName}
                    onChange={this.onChangeName} />
                </FormRow>
                <FormRow
                  variant="colM"
                  align="flex-start">
                  <Text variant="body3">What icon do you want to use?</Text>
                  {popover}
                </FormRow>
              </Flex>
            )}
            onYes={this.onCreateProject}
            onNo={this.onCancelProject} />

          <YesNoDialog
            show={showDeleteDialog}
            variant="dialogMedium"
            title={`Are you sure you want to delete the project "${deleteProject && deleteProject.name}"?`}
            yesVariant="primaryDestructive"
            yes="Delete"
            no="Cancel"
            message={(
              <Flex
                variant="colM"
                align="flex-start">
                <Text variant="body3">This will destroy all blueprints, systems, devices, networks in the project and is NOT RECOMMENDED</Text>
                <Label variant="large">Type DELETE in this box to continue</Label>
                <TextInput
                  focus
                  hint="Enter DELETE"
                  className={style.deleteTextField} 
                  value={deleteName}
                  onKeyDown={this.onEnterInDeleteProject}
                  changeOnReturn={false}
                  alwaysFireOnReturn={false}
                  onChange={this.onChangeDeleteName} />
              </Flex>
            )}
            onYes={this.onDeleteProject}
            onNo={this.onCancelDeleteProject} />
        </Content.Area>
      </Content>
    )
  }
}

// function testImport( this ) {
// if ( true ) {
//   const project = { id : 'xxxxxxxx', name : 'sample' }
//   const errors = [ ]
//   for ( let n = 0; n < 20; n++ ) {
//     errors.push( { message : `Bad news ${n}`, error : new Error( 'darn' ), value : n } )
//     for ( let m = 0; m < 100; m++ ) {
//       errors[n][`field_${m}`] = m
//     }
//   }
//   const notes = [ ]
//   for ( let n = 0; n < 3; n++ ) {
//     notes.push( { message : `Good news ${n}`, value : n } )
          
//   }
//   Dialogs.show( { 
//     component : ( prps ) => {
//       const onOkay = ( e ) => { prps.onClose() }
//       const onCancel = ( e ) => { prps.onClose() }
//       return (
//         <ImportResults.Dialog 
//           {...prps} 
//           okay="Open Project"
//           cancel="Done"
//           onOkay={onOkay} 
//           onCancel={onCancel}
//           project={project} 
//           notes={notes} 
//           errors={errors}/>
//       )
           
//     }
//   } )
//   return
// }
// }

export default connect(
  state => ( {
    projects : state.projects
  } )
)( HomeScreen )
